export default __webpack_public_path__ + "static/media/pink-3.f65a6a4d.png";